export default __webpack_public_path__ + "cd3fdd9fd6bab199a442292343504422.png";